import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test230325 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 23/03/2025 Candidates</h3>
      <br />
      <br />


        <div><Link to='/conduct-ronbanchoba'>1. ATT  7645  MR.RONBANCHOB APIRATIKUL(SHODAN-HO)---Trying for 1DAN</Link></div>
        <br />
        <div><Link to='/conduct-pawanratc'>2. ATT  7731  MS.PAWANRAT CHUPINIJSAK(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-santis'>3. ATT  7518  MR.SANTI SIRISAK(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-jacquesp'>4. ATT  7369  MR.JACQUES DU PLESSIS(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-wannatouchp'>5. ATT  7847  MR.WANNATOUCH PRASERT(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-anantayak'>6. ATT  7749  MS.ANANTAYA KULTANAKORN(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-chanchita'>7. ATT  7870  MR.CHANCHIT APISAMAJAN(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>8. ATT  7951  MS.NAPASANUN VONGVIVAT(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>9. ATT  7952  MR.ISSARIYAPA ROOPSUWANNAKUL(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-naphatsorny'>10. ATT  7954  MS.NAPHATSORN  YOTSIRIPORNCHAI(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-nutchan'>11. ATT  7955  MS.NUTCHA  NAKAEW(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-matsakaj'>12. ATT  8002  MR.MATSAKA JANSAWANG(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />






        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test230325;
